export default __webpack_public_path__ + "static/media/creditcard.7f3c64a1.png";